import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appCurrencyMask]',
})
export class CurrencyMaskDirective implements OnInit {
    constructor(private el: ElementRef, private control: NgControl) {}

    ngOnInit() {
        setTimeout(() => {
            if (this.control.value) {
                this.control.valueAccessor.writeValue(
                    this.formatCurrency(this.control.value)
                );
            }
        }, 100);
    }

    @HostListener('input', ['$event'])
    onInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D/g, '');
        value = (parseFloat(value) / 100).toFixed(2);
        const formattedValue = this.formatCurrency(value);
        input.value = formattedValue;

        this.control.viewToModelUpdate(Number(value));
    }

    private formatCurrency(value: string): string {
        value = value.toString();
        let parts = value.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        if (parts[0] === 'NaN') {
            parts[0] = '0';
        }
        return `R$ ${parts.join(',')}`;
    }
}
